import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import React from "react";
import { Controller } from "react-hook-form";
// import { useForm } from "react-hook-form";
// import { FormattedMessage } from "react-intl";
// import { Editor } from "@tinymce/tinymce-react";

// export function Form({ defaultValues, children, onSubmit }) {
//   const { handleSubmit, register, formState: { errors } } = useForm({ defaultValues });

//   return (
//     <form onSubmit={handleSubmit(onSubmit)}>
//       {Array.isArray(children)
//         ? children.map((child) => {
//           return child.props.name
//             ? React.createElement(child.type, {
//               ...{
//                 ...child.props,
//                 register,
//                 key: child.props.name,
//                 errors: errors
//               }
//             })
//             : child;
//         })
//         : children}
//     </form>
//   );
// }

export function Input({
	langId = "",
	register,
	name = "",
	errors,
	type = "text",
	rules = { required: true },
	className = "form-control form-outline",
	hint = null,
	...rest
}) {
	const nameWithoutLocale = name.split(".").at(0);
	const locale = name.split(".").length >= 2 ? name.split(".").at(-1) : "";
	return (
		<label
			className={`d-block form-group ${rules?.required && "required"} ${
				rest?.labelClass || ""
			}`}
		>
			<div className={rest?.wrapperStyle || ""}>
				{langId && (
					<div className="input-head-wrapper">
						<h5 className={hint && "hint-included"}>
							{/* <FormattedMessage id={langId} /> */}
							{langId}

							{locale === "ar" && <> (العربية) </>}
							{locale === "en" && <> (الانجليزية) </>}
						</h5>
						{hint && <span className="input-hint">( {hint} )</span>}
					</div>
				)}
				<div>
					<input
						type={type}
						className={className}
						{...register(name, { ...rules })}
						{...rest}
					/>
				</div>
			</div>
			<p className="error-hint">
				{(errors?.[nameWithoutLocale]?.[locale]?.type === "required" &&
					"	هذا الحقل مطلوب") ||
					(errors?.[nameWithoutLocale]?.type === "required" &&
						" هذا الحقل مطلوب") ||
					(errors?.[name]?.type === "required" && "	هذا الحقل مطلوب")}
			</p>
		</label>
	);
}

export function Textarea({ langId = "", register, name, errors, ...rest }) {
	const nameWithoutLocale = name.split(".").at(0);
	const locale = name.split(".").length >= 2 ? name.split(".").at(-1) : "";

	return (
		<label className="d-block form-group required">
			{langId && (
				<h5>
					{/* <FormattedMessage id={langId} /> */}
					{langId}

					{locale === "ar" && <> (العربية) </>}
					{locale === "en" && <> (الانجليزية) </>}
				</h5>
			)}
			<div>
				<textarea
					type="text"
					className="form-control form-outline"
					{...register(name, { required: true })}
					{...rest}
				></textarea>
			</div>
			<p className="error-hint">
				{locale !== ""
					? errors?.[nameWithoutLocale]?.[locale]?.type === "required" &&
					  " هذا الحقل مطلوب"
					: errors?.[nameWithoutLocale]?.type === "required" &&
					  " هذا الحقل مطلوب"}
			</p>
		</label>
	);
}

export function EditorComponent({
	langId = "",
	control,
	name,
	errors,
	...rest
}) {
	const nameWithoutLocale = name.split(".").at(0);
	const locale = name.split(".").length >= 2 ? name.split(".").at(-1) : "";
	let editor = null;
	return (
		<div className="d-block form-item">
			{langId && (
				<h5>
					{/* <FormattedMessage id={langId} /> */}
					{langId}

					{locale === "ar" && <> (العربية) </>}
					{locale === "en" && <> (الانجليزية) </>}
				</h5>
			)}
			<div>
				<Controller
					control={control}
					name={name}
					render={({ field: { value, onChange } }) => (
						<CKEditor
							key={rest?.index}
							id={name + rest?.index}
							data={value}
							onReady={editor => {
								editor.ui
									.getEditableElement()
									.parentElement.insertBefore(
										editor.ui.view.toolbar.element,
										editor.ui.getEditableElement()
									);
								// eslint-disable-next-line no-self-assign
								editor = editor;
							}}
							onError={({ willEditorRestart }) => {
								if (willEditorRestart) {
									editor.ui.view.toolbar.element.remove();
								}
							}}
							onBlur={(event, editor) => {
								const data = editor.getData();
								onChange(data);
							}}
							editor={DecoupledEditor}
							config={{
								contentsLangDirection: "rtl",
								language: "ar",
							}}
						/>
						// <textarea
						// 	type="text"
						// 	name={name}
						// 	className="form-control form-outline"
						// 	onChange={e => onChange(e.target?.value)}
						// 	value={value}
						// 	{...rest}
						// ></textarea>
					)}
				/>
			</div>
			<p className="error-hint">
				{locale !== ""
					? errors?.[nameWithoutLocale]?.[locale]?.type === "required" &&
					  " هذا الحقل مطلوب"
					: errors?.[nameWithoutLocale]?.type === "required" &&
					  " هذا الحقل مطلوب"}
			</p>
		</div>
	);
}
